module.exports = __webpack_public_path__ + "FuturaStd-Light.otf?b8434882ba3d39bc074d34f55586a816";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/FuturaStd-Light.otf
// module id = 91
// module chunks = 0